import type { ReactElement } from 'react'

import { EmptyStateIcon, NamingConventionsIcon } from '@segment/matcha/components/Icons/Brandbook'

type AdditionalResourcesCard = {
  icon: ReactElement
  link: { href: string }
  title?: string
  body: string
}

const data: Array<AdditionalResourcesCard> = [
  {
    icon: <EmptyStateIcon />,
    link: { href: `/product/privacy-portal/` },
    title: `Privacy & Compliance`,
    body: `Automatically detect and classify PII in real-time. By setting rules to proactively block, hash, and routine sensitive data, you can accelerate compliance with GDPR, CCPA, and more.`,
  },
  {
    icon: <NamingConventionsIcon />,
    link: { href: `/product/connections/` },
    title: `Standardize your data`,
    body: `Standardize data collection by creating a single tracking plan across all your web and mobile apps. `,
  },
]

export default data
